import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import AdminAccessReducer from "../AdminAccess/AdminAccessReducer";
import ChatConversationReducer from "../ChatConversation/ChatConversationReducer";
import ConversationReducer from "../Conversation/ConversationReducer";
import DashboardReducer from "../Dashboard/DashboardReducer";
import ErrorBoundaryReducer from "../ErrorBoundary/ErrorBoundaryReducer";
import { FileUploadReducer } from "../FileUpload/FileUploadReducer";
import HeaderReducer from "../Header/HeaderReducer";
import IUnderstandReducer from "../IUnderstand/IUnderstandReducer";
import RightSidebarReducer from "../RightSidebar/RightSidebarReducer";
import SidebarReducer from "../Sidebar/SidebarReducer";

export const rootReducer = combineReducers({
  IUnderstand: IUnderstandReducer,
  AdminAccess: AdminAccessReducer,
  Dashboard: DashboardReducer,
  Conversation: ConversationReducer,
  RightSidebar: RightSidebarReducer,
  Sidebar: SidebarReducer,
  Header: HeaderReducer,
  ChatConversation: ChatConversationReducer,
  Error: ErrorBoundaryReducer,
  FileUpload: FileUploadReducer
});
export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
});

export default store;